export default "__VITE_ASSET__ByhjkZwR__"